import { useCallback, useState } from 'react';
import type { AccountUser, FetchPartnerAccountUsersRequest } from 'vopay';
import { api } from '@/services/api.config';

/**
 * The partner portal's users: the logged-in partner's own, or — with `PartnerAccountID` — those of
 * a partner account it created.
 */
export default function useFetchUsers() {
  const [fetchingUsers, setFetchingUsers] = useState(false);
  const [users, setUsers] = useState<AccountUser[]>([]);

  const fetchUsers = useCallback(async (params?: FetchPartnerAccountUsersRequest) => {
    try {
      setFetchingUsers(true);
      const res = await api.fetchPartnerAccountUsers(params);

      if (!res.Success) throw new Error(res.ErrorMessage);

      setUsers(res.Users);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetchingUsers(false);
    }
  }, []);

  return { fetchingUsers, users, fetchUsers };
}
